import { render } from "./SecondModel2.vue?vue&type=template&id=110bf333"
import script from "./SecondModel2.vue?vue&type=script&lang=js"
export * from "./SecondModel2.vue?vue&type=script&lang=js"

import "./SecondModel2.vue?vue&type=style&index=0&id=110bf333&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__